module.exports = __webpack_public_path__ + "app/assets/images/man12-9c058d84393cf31607267324f8356326.jpg";